import React from 'react';
import { clientErrors } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import fields from '@/constants/fields';
import FormValidationError from '@/components/errors/FormValidationError';
import ConditionsDropdown from './ConditionsDropdown';

const DatasetConditionsDropdown = ({
  changeCondition,
  conditions,
  isNew,
  readStatus,
  saveErrors,
  saveStatus,
  selectedCondition,
}) => {
  const error = clientErrors(saveErrors).find((e) => e.fields.includes(fields.CODE));
  return (
    <FormValidationError
      error={error}
      htmlFor="conditions_dropdown"
      labelId="dataset.condition.dropdown.label"
    >
      <ConditionsDropdown
        conditions={conditions}
        disabled={saveStatus === states.PENDING || !isNew || conditions?.length === 0}
        error={!!error}
        onChange={changeCondition}
        readStatus={readStatus}
        selectedCondition={selectedCondition}
        withDescription
      />
    </FormValidationError>
  );
};

export default DatasetConditionsDropdown;
